<template>
    <div class="blogger-project-container">
      <v-row dense class="blogger-project-row">
        <v-col
          v-for="item in items"
          :key="item.title"
          cols="12"  md="3"
          class="project-col">
            <v-card max-width="300" min-width="180" class="mx-auto blogger-project-card">
                <!-- 项目名称 -->
                <v-list-item>
                    <v-list-item-avatar><img :src="item.avatar"></v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <!-- 缩略图 -->
                <!-- <v-img :alt="item.name" :src="item.img" style="margin-left:20px" height="194" width="88%"></v-img> -->
                <photo-card class="project-photo-image" :img="item.img" :name="item.name"
                    :link="item.link" :height="'210px'" :width="'100%'"></photo-card>
                <!-- demo github地址 -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom v-if="item.docment">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="black accent-4"  v-bind="attrs" v-on="on" @click="projectClick(item.docment)">
                                <v-icon>mdi-file</v-icon>
                            </v-btn>
                        </template>
                        <span>项目文档</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="item.demo">
                        <template v-slot:activator="{ on, attrs }">
                             <v-btn icon color="black accent-4" v-bind="attrs" v-on="on" @click="projectClick(item.demo)">
                                <v-icon>mdi-youtube</v-icon>
                            </v-btn>
                        </template>
                        <span>项目demo</span>
                    </v-tooltip>
   
                    <v-tooltip bottom v-if="item.link">
                        <template v-slot:activator="{ on, attrs }">
                             <v-btn icon color="black accent-4" v-bind="attrs" v-on="on" @click="projectClick(item.link)">
                                <v-icon>mdi-github</v-icon>
                            </v-btn>
                        </template>
                        <span>项目地址</span>
                    </v-tooltip>
  
                </v-card-actions>
            </v-card>
        </v-col>
      </v-row>
    </div>
</template>

<script>
import IMG1 from '@/assets/imgs/project/1.jpg'
import IMG3 from '@/assets/imgs/project/3.jpg'
import IMG4 from '@/assets/imgs/project/4.jpg'
import IMG10 from '@/assets/imgs/project/10.jpg'

import HALFLEAF from '@/assets/imgs/logo.png'
import MAYBE from '@/assets/imgs/nav/maybe.png'
import MYSELF from '@/assets/imgs/project/myself.png'
// import LOVETALK from '@/assets/imgs/nav/lovetalk.png'
import INTERVIEW from '@/assets/imgs/nav/interview.png'

import photoCard from "@/components/photoCard.vue"

export default {
    components: {
        photoCard,
    },
    data() {
        return {
            items:[
                // {
                //     name:"情话小铺",
                //     avatar:LOVETALK,
                //     img:IMG1,
                //     desc:"情话铺子，哄女孩子从会说情话开始",
                //     link:"https://github.com/HalfLeaf/LoveTalk-Store",
                //     demo:"",
                //     docment:""
                // },
                {
                    name:"个人主页",
                    avatar:HALFLEAF,
                    img:IMG1,
                    desc:"个人主页",
                    link:"https://gitee.com/half-leaf/home-page",
                    demo:"http://halfleaf.github.io/",
                    docment:""
                },
                {
                    name:"Myself",
                    avatar:MYSELF,
                    img:IMG4,
                    desc:"记录个人常用的python方法",
                    link:"https://github.com/HalfLeaf/myself",
                    demo:"",
                    docment:""
                },
                {
                    name:"Maybe",
                    avatar:MAYBE,
                    img:IMG3,
                    desc:"接口自动化测试框架",
                    link:"https://github.com/HalfLeaf/Maybe",
                    demo:"",
                    docment:""
                },
                {
                    name:"Interview",
                    avatar:INTERVIEW,
                    img:IMG10,
                    desc:"进击的面试题",
                    link:"https://github.com/HalfLeaf/interview",
                    demo:"",
                    docment:""
                },

            ]
        }
    },
    methods: {
        projectClick(item){
            window.open(item,'_blank')
        }
    },
}
</script>

<style lang="stylus" scoped>
.blogger-project-container
  position absolute
  top  0
  bottom 0
  border 0
  left 0
  width  100%
  height  100%
  overflow  auto
  background-size  cover
  background-image url("../assets/imgs/bg/7.jpg")

.blogger-project-card
    margin-top 20px
    background-color #E0F7FA

.blogger-project-row
  margin-left  270px
  margin-top 32px

.project-col
  margin-left 25px

.project-photo-image
  margin-left  -20px
  height  210px

</style>